import { keepPreviousData } from "@tanstack/react-query";
import { api } from "convex/_generated/api";
import type { UIAudit } from "@/packages/types";
import { useWorkspaceQuery } from "@/hooks";

interface UseAuditsReturn {
  audits: UIAudit[] | undefined;
  isLoading: boolean;
}

export function useAudits(): UseAuditsReturn {
  const { data, isLoading } = useWorkspaceQuery(
    api.audit_queries.listAudits,
    {},
    { placeholderData: keepPreviousData },
  );

  return {
    audits: data as UIAudit[] | undefined,
    isLoading,
  };
}
